import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

function PageHeader ({ extraClass, title, subtitle, children }) {
  const mainClasses = classnames(extraClass, 'page-header__main relative')
  return (
    <div className='page-header'>
      <div className={mainClasses}>
        <div className='page-header__content col-10 center maxw-xlarge mx-auto'>
          {title && (
            <h1 className='hero col-10 md-col-8 lg-col-10 mx-auto mb2'>
              {typeof title === 'string' ? (
                <div
                  className='page-header__title mb2'
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              ) : (
                <div>{title}</div>
              )}
              {subtitle && typeof subtitle === 'string' ? (
                <div
                  className='page-header__subtitle grey mx-auto'
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              ) : (
                <div>{subtitle}</div>
              )}
            </h1>
          )}
          <div className='page-header__body'>{children && children}</div>
        </div>
      </div>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string, // html
    PropTypes.node // React element
  ]),
  subtitle: PropTypes.string,
  extraClass: PropTypes.string,
  children: PropTypes.node
}

PageHeader.defaultProps = {
  // so occupies space even before page data has loaded (and no title present)
  title: '&nbsp;'
}

export default PageHeader



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/PageHeader.js